export default __webpack_public_path__ + "static/media/facebook.4ddd7be4.svg";